import { withStyles } from "@mui/styles";
import { Styles } from "./Style";
import ProductList from "../PickupPlan/ProductList/ProductList";
const ItemMenu = (props) => {
  const { classes, onPage } = props;
  return <ProductList onProp={onPage} />;
};

export default withStyles(Styles)(ItemMenu);
